import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LuBike, LuStore, LuMapPin, LuClock3 } from "react-icons/lu";
import { updateChekoutDeliveryMethod } from "../reducers/userConfigSlice";

export const deliveryKind = method => method?.homeDeliveryIsActive === true ? "home" : method?.storeDeliveryIsActive === true ? "pickup" : null;
export const availableDeliveryMethods = methods => (Array.isArray(methods) ? methods : []).filter(deliveryKind);
export const StoreDelivery = ({ children }) => {
  const dispatch = useDispatch();
  const raw = useSelector(state => state.aplicationConfig.corporationData.info?.corporation?.ShippingMethods);
  const methods = useMemo(() => availableDeliveryMethods(raw), [raw]);
  const selected = useSelector(state => state.aplicationConfig.userConfig.checkout.deliveryMethod);
  const kind = deliveryKind(selected);
  const pickup = useMemo(() => methods.filter(method => deliveryKind(method) === "pickup"), [methods]);
  const home = useMemo(() => methods.filter(method => deliveryKind(method) === "home"), [methods]);
  useEffect(() => {
    if (!methods.length) return;
    if (!methods.some(method => method.shippingMethodId === selected?.shippingMethodId)) dispatch(updateChekoutDeliveryMethod(pickup[0] || methods[0]));
  }, [dispatch, methods, selected?.shippingMethodId, pickup]);
  if (!methods.length) return children || null;
  const choices = kind === "home" ? home : pickup;
  return <div className="eats-delivery">
    <div className="eats-service-badges">
      {!!pickup.length && <span><LuClock3 aria-hidden="true" />Recogida</span>}
      {!!home.length && <span><LuBike aria-hidden="true" />Entrega a domicilio</span>}
    </div>
    {children}
    <div className="eats-delivery-toggle" role="group" aria-label="Cómo recibir tu pedido">
      <button type="button" aria-pressed={kind === "pickup"} disabled={!pickup.length} onClick={() => dispatch(updateChekoutDeliveryMethod(pickup.find(method => method.shippingMethodId === selected?.shippingMethodId) || pickup[0]))}><LuStore aria-hidden="true" />Recoger</button>
      <button type="button" aria-pressed={kind === "home"} disabled={!home.length} onClick={() => dispatch(updateChekoutDeliveryMethod(home.find(method => method.shippingMethodId === selected?.shippingMethodId) || home[0]))}><LuBike aria-hidden="true" />A domicilio</button>
    </div>
    <div className="eats-delivery-info">
      <LuMapPin aria-hidden="true" /><span>{kind === "home" ? "Entrega:" : "Recogida:"}</span>
      {choices.length <= 1 && <strong>{kind === "home" ? selected?.nameHomeDelivery : selected?.nameStoreDelivery}</strong>}
      {choices.length > 1 && <select aria-label={kind === "home" ? "Método de entrega" : "Método de recogida"} value={selected?.shippingMethodId || ""} onChange={event => dispatch(updateChekoutDeliveryMethod(choices.find(method => method.shippingMethodId === event.target.value)))}>
        {choices.map(method => <option key={method.shippingMethodId} value={method.shippingMethodId}>{kind === "home" ? method.nameHomeDelivery : method.nameStoreDelivery}</option>)}
      </select>}
    </div>
  </div>;
};
